import { CurrencyISO } from '@/constants/currencies';
import { useNarrativeValuationOptions } from '../../../hooks/useNarrativeValuationOptions';
import { useMemo } from 'react';
import useUser from '@/hooks/useUser';

type Props = {
  companyId: string;
};

export const useValuationSelectionFormData = ({ companyId }: Props) => {
  const { data: user } = useUser();
  const { data: valuationOptionsData } = useNarrativeValuationOptions({
    companyId,
  });
  const isNarrativeOnboardingComplete = Boolean(user.displayName);
  const userId = user?.id;

  return useMemo(() => {
    const { company } = valuationOptionsData ?? {};
    const {
      valuationOptions,
      name: companyName,
      tickerSymbol,
      analysisValue,
      data,
    } = company ?? {};
    const { priceTargetAnalystCount } = analysisValue ?? {};
    const { currencyInfo } = data ?? {};
    const companyCurrencyISO = (
      currencyInfo as { trading_item_currency_iso: CurrencyISO }
    )?.trading_item_currency_iso;

    const myNarrative =
      valuationOptions?.find(
        (option) =>
          option.type === 'USER_DEFINED' &&
          userId &&
          option.valuation?.narrative?.author?.id === userId
      ) ?? null;

    return {
      isNarrativeOnboardingComplete,

      valuationOptions,
      companyName,
      tickerSymbol,
      priceTargetAnalystCount,
      companyCurrencyISO,
      myNarrative,
    };
  }, [valuationOptionsData, isNarrativeOnboardingComplete, userId]);
};
